import { isBrowser } from "react-device-detect";
import LargeScreenNavbar from "./LargeScreenNavbar";
import SmallScreenNavbar from "./SmallScreenNavbar";

const Navbar = () => {
  return <>{isBrowser ? <LargeScreenNavbar /> : <SmallScreenNavbar />}</>;
};

export default Navbar;
